<template>
  <div id="app-41">
    <LmsMssComponent endpoint="gettaf" source="data" header_filter="FCSQ41" show_header="true" />
  </div>
</template>

<script>
import LmsMssComponent from "@/components/LmsMssComponent";

export default {
  name: 'app',
  components: {
    LmsMssComponent,
  }
}
</script>
